import { defineSlotRecipe } from '@chakra-ui/react'

export const snackbar = defineSlotRecipe({
  className: 'Snackbar',
  slots: ['button', 'closeButton', 'container', 'description', 'icon', 'title'],
  base: {
    container: {
      bg: 'brand.cityGreen5',
      borderColor: 'brand.darkCityGreen',
      position: 'relative',
    },
    icon: {
      color: 'brand.darkCityGreen',
    },
  },
  variants: {
    variant: {
      warning: {
        container: { borderColor: 'brand.orange30', bgColor: 'brand.orange5' },
      },
      error: {
        container: { borderColor: 'error.primary', bgColor: 'brand.red5' },
      },
      success: {
        container: { borderColor: 'brand.primaryTeal', bgColor: 'brand.shamrockGreen10' },
      },
      promo: {
        container: {
          bg: 'brand.cityGreen5',
          borderColor: 'brand.cityGreen',
          '> svg': {
            color: 'brand.cityGreen',
          },
          'p:first-child': {
            fontWeight: 'medium',
            pb: 2,
          },
          strong: {
            fontWeight: 'medium',
          },
        },
      },
    },
  },
})
